var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.getters.toastAlert)?_c('div',{staticClass:"toast-alert px-5 py-3",class:_vm.$store.getters.toastAlert.class || 'success',domProps:{"textContent":_vm._s(_vm.$store.getters.toastAlert.text)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }